/* Vexira theme script. One file for every template: menus, rails, collection grid toggle,
   product page, bag drawer and cart page and shop-the-look. The motion and the look of the home page are in vexira-motion.js. No dependencies. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement, body = doc.body;
  root.classList.add('js');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || doc).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* scrollbar width, so widths set in viewport units match the visible page */
  function sb() { root.style.setProperty('--sb', (innerWidth - root.clientWidth) + 'px'); }
  sb(); addEventListener('resize', sb);

  /* ---------- money ---------- */
  var moneyFormat = body.getAttribute('data-money-format') || 'Rs. {{amount}} INR';
  function group3(n, thousands, decimal, precision) {
    var s = (n / 100).toFixed(precision).split('.');
    s[0] = s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return s[0] + (s[1] ? decimal + s[1] : '');
  }
  function money(cents) {
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount', v;
    switch (kind) {
      case 'amount_no_decimals': v = group3(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator': v = group3(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': v = group3(cents, '.', ',', 0); break;
      case 'amount_with_apostrophe_separator': v = group3(cents, "'", '.', 2); break;
      case 'amount_no_decimals_with_space_separator': v = group3(cents, ' ', '.', 0); break;
      default: v = group3(cents, ',', '.', 2);
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- small toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = doc.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 3200);
  }

  /* header look (clear over the film, mint bar, hide on scroll) and the front film: see vexira-motion.js */
  var hdr = $('#hdr'), mega = $('#mega');

  /* mega menu (large screens). Only opens for menu items that have sub-links. */
  var closeT;
  function showMega(id) {
    if (!mega || !$('.mg[data-for="' + id + '"]', mega)) return;
    clearTimeout(closeT);
    $$('.mg', mega).forEach(function (m) { m.classList.toggle('on', m.getAttribute('data-for') === id); });
    $$('.nav a').forEach(function (a) { a.classList.toggle('on', a.getAttribute('data-menu') === id); });
    mega.removeAttribute('hidden'); mega.classList.add('on'); hdr.classList.add('open'); hdr.classList.remove('hide');
  }
  function hideMega() {
    if (!mega) return;
    closeT = setTimeout(function () { mega.classList.remove('on'); hdr.classList.remove('open'); $$('.nav a').forEach(function (a) { a.classList.remove('on'); }); }, 120);
  }
  if (hdr && mega) {
    $$('.nav a').forEach(function (a) {
      var wide = function () { return matchMedia('(min-width:900px)').matches; };
      a.addEventListener('mouseenter', function () { if (wide()) { if (a.hasAttribute('data-mega')) showMega(a.getAttribute('data-menu')); else hideMega(); } });
      a.addEventListener('focus', function () { if (wide() && a.hasAttribute('data-mega')) showMega(a.getAttribute('data-menu')); });
    });
    hdr.addEventListener('mouseleave', hideMega);
    mega.addEventListener('mouseenter', function () { clearTimeout(closeT); });
  }

  /* ---------- menu drawer (phones) ---------- */
  var drawer = $('#drawer'), burger = $('#burger');
  function openDrawer() { if (!drawer) return; drawer.removeAttribute('hidden'); requestAnimationFrame(function () { drawer.classList.add('on'); }); burger.setAttribute('aria-expanded', 'true'); body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer || !drawer.classList.contains('on')) return; drawer.classList.remove('on'); burger.setAttribute('aria-expanded', 'false'); body.style.overflow = ''; }
  if (drawer && burger) {
    burger.addEventListener('click', openDrawer);
    var dx = $('#dx'); if (dx) dx.addEventListener('click', closeDrawer);
    var ds = $('.dr-scrim', drawer); if (ds) ds.addEventListener('click', closeDrawer);
    $$('a', drawer).forEach(function (l) { l.addEventListener('click', closeDrawer); });
  }

  /* ---------- horizontal rails: arrows and progress ---------- */
  $$('[data-rail]').forEach(function (rail) {
    var scope = rail.closest('section') || rail.parentNode;
    var prev = $('[data-rail-prev]', scope), next = $('[data-rail-next]', scope), prog = $('[data-rail-prog]', scope);
    var step = function () { var c = $('.pc', rail); return c ? c.offsetWidth + 4 : 300; };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    var progress = function () {
      if (!prog) return;
      var sw = rail.scrollWidth || 1;
      prog.style.width = Math.min(100, rail.clientWidth / sw * 100).toFixed(1) + '%';
      prog.style.left = (rail.scrollLeft / sw * 100).toFixed(1) + '%';
    };
    rail.addEventListener('scroll', progress, { passive: true }); addEventListener('resize', progress); progress();
  });

  /* ---------- collection grid toggle ---------- */
  var cg = $('#cgrid');
  $$('.gt button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!cg) return;
      cg.classList.toggle('few', b.getAttribute('data-g') === 'few');
      $$('.gt button').forEach(function (x) { x.classList.toggle('on', x === b); });
    });
  });

  /* ---------- cart (shared by the drawer, the bag page and the product page) ---------- */
  var cartDrawerOn = body.getAttribute('data-cart-drawer') === 'true';
  var freeAt = parseInt(body.getAttribute('data-free-shipping'), 10) || 0;
  var cartUrl = body.getAttribute('data-cart-url') || '/cart';
  var cd = $('#cd'), cdBody = $('#cd-body'), cdFoot = $('#cd-foot');

  function req(url, data) {
    return fetch(url, {
      method: data ? 'POST' : 'GET',
      headers: data ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: data ? JSON.stringify(data) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function imgUrl(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function setCount(n) { $$('[data-bag-count]').forEach(function (e) { e.textContent = n; }); var c = $('#cd-count'); if (c) c.textContent = n ? '(' + n + ')' : ''; }

  function lineHtml(it, i) {
    var variant = it.product_has_only_default_variant ? '' : '<span>' + esc(it.variant_title) + '</span>';
    return '<div class="cl" data-line="' + (i + 1) + '">' +
      '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" width="84" height="126" alt="' + esc(it.product_title) + '">' : '') + '</a>' +
      '<div class="cl-t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + '<span>' + money(it.final_price) + '</span>' +
      '<div class="cl-r"><div class="qty"><button type="button" data-q="-1" aria-label="Decrease quantity">&minus;</button><output>' + it.quantity + '</output><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="rm" data-rm>Remove</button></div></div></div>';
  }

  function drawDrawer(cart) {
    if (!cd) return;
    setCount(cart.item_count);
    var ship = $('#cd-ship');
    if (!cart.item_count) {
      cdBody.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn" href="' + esc(body.getAttribute('data-shop-url') || '/collections/all') + '">Continue shopping</a></div>';
      cdFoot.hidden = true; ship.hidden = true; return;
    }
    cdBody.innerHTML = cart.items.map(lineHtml).join('');
    $('#cd-total').textContent = money(cart.total_price);
    cdFoot.hidden = false;
    if (freeAt) {
      ship.hidden = false;
      var left = freeAt - cart.total_price;
      $('#cd-ship-t').textContent = left > 0 ? money(left) + ' away from free shipping' : 'You have free shipping';
      $('#cd-ship-b').style.width = Math.min(100, cart.total_price / freeAt * 100).toFixed(1) + '%';
    } else ship.hidden = true;
  }

  function openCart(added) {
    if (!cd) return;
    cd.hidden = false;
    var a = $('#cd-added'); if (a) a.hidden = !added;
    requestAnimationFrame(function () { cd.classList.add('on'); });
    body.style.overflow = 'hidden';
    var x = $('#cd-x'); if (x) x.focus();
  }
  function closeCart() {
    if (!cd || !cd.classList.contains('on')) return;
    cd.classList.remove('on'); body.style.overflow = '';
    setTimeout(function () { cd.hidden = true; }, reduce ? 0 : 420);
  }

  function refreshCartPage() {
    var pageBody = $('#cart-page-body');
    if (!pageBody) return Promise.resolve();
    return fetch(location.pathname, { headers: { 'Accept': 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-page-body');
      if (fresh) pageBody.innerHTML = fresh.innerHTML;
    });
  }

  function refreshCart(opts) {
    opts = opts || {};
    return req('/cart.js').then(function (cart) {
      drawDrawer(cart);
      return refreshCartPage().then(function () { return cart; });
    }).then(function (cart) { if (opts.open) openCart(opts.added); return cart; });
  }

  function change(line, qty) {
    return req('/cart/change.js', { line: line, quantity: qty }).then(function (cart) {
      drawDrawer(cart);
      return refreshCartPage();
    }).catch(function () { toast('Could not update your bag. Please try again.'); });
  }

  /* quantity and remove, in the drawer and on the bag page */
  doc.addEventListener('click', function (e) {
    var line = e.target.closest('.cl[data-line]');
    if (!line) return;
    var n = parseInt(line.getAttribute('data-line'), 10);
    var qtyEl = $('output', line), cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-rm]')) { e.preventDefault(); change(n, 0); return; }
    var q = e.target.closest('[data-q]');
    if (q) { e.preventDefault(); change(n, Math.max(0, cur + parseInt(q.getAttribute('data-q'), 10))); }
  });

  if (cd) {
    var scrim = $('.cd-scrim', cd), cx = $('#cd-x');
    if (scrim) scrim.addEventListener('click', closeCart);
    if (cx) cx.addEventListener('click', closeCart);
    if (cartDrawerOn && !$('[data-cart-page]')) {
      doc.addEventListener('click', function (e) {
        var b = e.target.closest('a.bagc');
        if (!b || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        refreshCart({ open: true });
      });
    }
    req('/cart.js').then(drawDrawer).catch(function () {});
  }

  /* ---------- product page ---------- */
  var info = $('.pdp-i');
  if (info) {
    var pj = $('[data-product-json]'), product = null;
    try { product = pj ? JSON.parse(pj.textContent) : null; } catch (er) { product = null; }
    var form = $('#product-form', info), err = $('[data-error]', info), idInput = $('[data-variant-id]', info);
    var addBtn = $('[data-add]', info), addLabel = $('[data-add-label]', info), priceEl = $('[data-price]', info);
    var needsChoice = idInput && idInput.hasAttribute('data-needs-choice');
    var sets = $$('fieldset[data-option-index]', info);

    var chosen = function () {
      var vals = [];
      sets.forEach(function (fs) { var r = $('input:checked', fs); vals[+fs.getAttribute('data-option-index')] = r ? r.value : null; });
      return vals;
    };
    var match = function (vals) {
      if (!product) return null;
      return product.variants.filter(function (v) { return vals.every(function (x, i) { return x === null || x === undefined || v.options[i] === x; }); })[0] || null;
    };
    var allChosen = function (vals) { return sets.length > 0 && sets.every(function (fs) { return vals[+fs.getAttribute('data-option-index')]; }); };

    var showVariant = function (v) {
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to Bag' : 'Sold out';
      priceEl.innerHTML = (v.compare_at_price > v.price ? '<s class="was">' + money(v.compare_at_price) + '</s> ' : '') + money(v.price);
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    };

    sets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        if (err) err.hidden = true;
        var vals = chosen();
        if (allChosen(vals)) showVariant(match(vals));
      });
    });

    /* preselect from ?variant= */
    var qv = new URLSearchParams(location.search).get('variant');
    if (qv && product) {
      var pv = product.variants.filter(function (v) { return String(v.id) === qv; })[0];
      if (pv && sets.length) {
        sets.forEach(function (fs) { var r = $$('input', fs).filter(function (x) { return x.value === pv.options[+fs.getAttribute('data-option-index')]; })[0]; if (r) r.checked = true; });
        showVariant(pv);
      }
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vals = chosen();
      if (needsChoice && !allChosen(vals)) { if (err) { err.textContent = sets.length > 1 ? 'Choose your options' : 'Choose a ' + ($('legend', sets[0]).textContent.replace(':', '').toLowerCase()); err.hidden = false; } return; }
      if (addBtn.disabled) return;
      addBtn.classList.add('busy'); addBtn.disabled = true;
      req('/cart/add.js', { id: parseInt(idInput.value, 10), quantity: 1 }).then(function () {
        if (cartDrawerOn && cd) return refreshCart({ open: true, added: true });
        location.href = cartUrl;
      }).catch(function (j) {
        if (err) { err.textContent = (j && j.description) || 'Could not add this to your bag.'; err.hidden = false; }
      }).then(function () { addBtn.classList.remove('busy'); addBtn.disabled = false; });
    });

    $$('.tabs button', info).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.tabs button', info).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        $$('.tp', info).forEach(function (t) { t.hidden = t.id !== b.getAttribute('data-t'); });
      });
    });
  }

  /* ---------- recommendations ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!url || !('IntersectionObserver' in window)) return;
    var done = false;
    new IntersectionObserver(function (es, obs) {
      if (done || !es.some(function (x) { return x.isIntersecting; })) return;
      done = true; obs.disconnect();
      fetch(url).then(function (r) { return r.text(); }).then(function (t) {
        var fresh = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; }
      }).catch(function () {});
    }, { rootMargin: '400px 0px' }).observe(box);
  });

  /* ---------- shop the look ---------- */
  var ld = $('#looks-data');
  function closeModal() { var m = $('.modal.on'); if (m) { m.classList.remove('on'); body.style.overflow = ''; } }
  if (ld) {
    var looks = [], modal;
    try { looks = JSON.parse(ld.textContent); } catch (er2) { looks = []; }
    var build = function () {
      modal = doc.createElement('div'); modal.className = 'modal'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Shop the look');
      modal.innerHTML = '<div class="mp"><button class="mp-x" type="button" aria-label="Close"></button><div class="mp-img"></div><div class="mp-i"></div></div>';
      body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.mp-x')) closeModal(); });
    };
    var openLook = function (i) {
      var l = looks[i]; if (!l) return;
      if (!modal) build();
      $('.mp-img', modal).innerHTML = l.img ? '<img src="' + esc(l.img) + '" alt="' + esc(l.title) + '">' : '';
      var items = l.items || [];
      $('.mp-i', modal).innerHTML = '<h2>' + esc(l.title) + '</h2>' +
        items.map(function (it) { return '<a class="row" href="' + esc(it.url) + '"><span>' + esc(it.name) + '</span><span>' + esc(it.price) + '</span></a>'; }).join('') +
        (items.length ? '<a class="btn" href="' + esc(items[0].url) + '">View ' + (items.length > 1 ? 'the pieces' : 'the piece') + '</a>' : '');
      modal.classList.add('on'); body.style.overflow = 'hidden'; $('.mp-x', modal).focus();
    };
    $$('.stl').forEach(function (b) { b.addEventListener('click', function () { openLook(+b.getAttribute('data-i')); }); });
  }

  addEventListener('keydown', function (e) { if (e.key === 'Escape') { hideMega(); closeDrawer(); closeCart(); closeModal(); } });

  /* footer: back to top */
  $$('[data-top]').forEach(function (b) { b.addEventListener('click', function () { if (window.vxLenis) window.vxLenis.scrollTo(0, { duration: 1.2 }); else scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); }); });
})();
